import { use } from "react";
import { TracksListContext } from "./TracksListContext";
// création de hooks personnalisés pour accéder aux différents stores

export  const useTracksListStore = () => {
  const tracksListStore = use(TracksListContext);
  if (!tracksListStore) {
    throw new Error("useExponiaStore must be used within an ExponiaProvider");
  }
  return tracksListStore;
};

export const useAlbumStore = () => {
  const tracksListStore = useTracksListStore();
  return tracksListStore.albumStore;
};

export const useProfilStore = () => {
  const tracksListStore = useTracksListStore();
  return tracksListStore.profilStore;
};

export const useGameStore = () => {
  const tracksListStore = useTracksListStore();
  return tracksListStore.gameStore;
};

export const useProfilPlayerStore = () => {
  const tracksListStore = useTracksListStore();
  return tracksListStore.profilPlayerStore;
};


// export const useExpoStore = () => {
//   const exponiaStore = useExponiaStore();
//   return exponiaStore.expoStore;
// };
